"use client";
import Image from "next/image";
import Link from "next/link";
import { FontAwesomeIcon, VeBox, VeTypography } from "@packages/ui/mui";
import { BACK_ICON, CHEVRON_LEFT } from "@public/index";
import { faChevronLeft } from "@packages/ui/libs";

interface backTypes {
  text: string;
  link: string;
  marginTop?: boolean;
}

const ReturnSignIn = ({ text, link, marginTop = true }: backTypes) => {
  return (
    <VeBox>
      <Link href={link}>
        <VeBox
          marginTop={marginTop ? "24px" : undefined}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          gap="4px"
        >
          <Image src={CHEVRON_LEFT} alt="back" />

          <VeTypography variant="label2StrongBrand">{text}</VeTypography>
        </VeBox>
      </Link>
    </VeBox>
  );
};

export default ReturnSignIn;
